var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoAgroresultadista(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80.83 12.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{font-size:11.81px;fill:#ed008e;font-family:HelveticaNeueLTStd-Blk, HelveticaNeueLTStd Blk;}.cls-2{letter-spacing:-0.02em;}.cls-3{letter-spacing:-0.02em;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo agroresultadista") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(0 9.89)"
  }, "Ag", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 13.83,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 17.49,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 23.98,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 27.64,
    y: 0
  }, "esultadista"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAgroresultadista);
export default __webpack_public_path__ + "static/media/logo-agroresultadista.07dbaa5030802cb19bae2900c8479c87.svg";
export { ForwardRef as ReactComponent };